import React, { FC, useCallback, useEffect, useRef } from "react";
import QuickPinchZoom, { make3dTransformValue } from "react-quick-pinch-zoom";

interface ImageProps {
  imgUrl: string;
  className: string;
  clickSlideImage: (e: any) => void;
}

export const Image: FC<ImageProps> = ({ imgUrl, className,clickSlideImage }) => {
  const imgRef = useRef<HTMLImageElement>(null);
  const quickPinchZoomRef = useRef<any>(null);

  const onUpdate = ({ x, y, scale }: { x: number, y: number, scale: number }) => {
    const img = imgRef.current;

    if (img && img.complete) {
      const value = make3dTransformValue({ x, y, scale });
      img.style.setProperty("transform", value);
      img.style.opacity = "1";
    } else if (img) {
      const value = make3dTransformValue({ x: 0, y: 0, scale: 1 });
      img.style.setProperty("transform", value);
      img.style.opacity = "0";
    }
  };

  const resetZoom = () => {
    const img = imgRef.current;
    if (!img) return;
    const { width, height } = img;
    const centerX = width / 2;
    const centerY = height / 2;

    quickPinchZoomRef.current.alignCenter({ x: centerX, y: centerY, scale: 1 });
  };

  return (
      <QuickPinchZoom
          onUpdate={onUpdate}
          ref={quickPinchZoomRef}
          draggableUnZoomed={false}
          shouldInterceptWheel={() => true}
          onDragEnd={resetZoom}
          onZoomEnd={resetZoom}
          onDoubleTap={resetZoom}
      >
        <img
            className={`${className} overflow-y-scroll`}
            src={imgUrl}
            alt="zoomed-item"
            ref={imgRef}
            onClick={clickSlideImage}
        />
      </QuickPinchZoom>
  );
};
